import React, { useMemo } from "react"

import { useNavigate } from "react-router-dom"

import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { MFAType } from "../../../../config/auth.config"
import { UtilHelper } from "../../../../helpers/util.helper"
import { useAppDispatch } from "../../../../store/appDispatch.hook"
import { useAppSelector } from "../../../../store/selectors/app.selector"
import { authSelector } from "../../../../store/selectors/auth.selector"
import { authProcessMfaCode } from "../../../../store/thunks/auth.thunks"
import { CodeForm } from "../../mfa/codeForm"

export const SMSCodeStep: React.FunctionComponent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const authState = useAppSelector(authSelector)

    const onSubmit = (code: string, rememberDevice?: boolean) => {
        dispatch(
            authProcessMfaCode({
                payload: {
                    code,
                    withLoggingIn: true,
                    mfaType: MFAType.SMS,
                    rememberDevice,
                },
                navigate,
            }),
        )
    }

    const maskedPhoneNumber = useMemo<string | undefined>(() => {
        return authState.mfaChallengePhoneNumber
            ? UtilHelper.maskString(authState.mfaChallengePhoneNumber)
            : undefined
    }, [authState.mfaChallengePhoneNumber])

    return (
        <div className="relative">
            <PrimaryText
                className="whitespace-pre-wrap mb-[24px]"
                typography="h3"
            >
                Enter the code sent to your phone
            </PrimaryText>

            <PrimaryText
                className="whitespace-pre-wrap mb-[24px]"
                typography="text"
                size={20}
            >
                A code was sent as an SMS to{" "}
                {maskedPhoneNumber || "your phone number"}.{`\n`}Please enter
                this code to continue.
            </PrimaryText>

            <CodeForm
                isCtaLoading={authState.isLoading}
                onSubmit={onSubmit}
                mfaType={MFAType.SMS}
                submitText="Submit"
            />

            <PrimaryText size={14} lineHeight={21} className="max-w-[400px]">
                Trouble with MFA? Contact your organization’s administrator to
                help reset your MFA.
            </PrimaryText>
        </div>
    )
}
